// extracted by mini-css-extract-plugin
module.exports = {"itemContent":"ItemContent_itemContent__VgPye","block":"ItemContent_block__32WSd"};